import React from 'react';
import { Route, Switch } from 'react-router-dom';

import ModalAcknowledgeIncident from './Modals/ModalAcknowledgeIncident';
import ModalAddNote from './Modals/ModalAddNote';
import ModalAddResponders from './Modals/ModalAddResponders';
import ModalChangePriority from './Modals/ModalChangePriority';
import ModalCreateIncident from './Modals/ModalCreateIncident';
import ModalLinkIncident from './Modals/ModalLinkIncident';
import ModalLinkUsers from './Modals/ModalLinkUsers';
import ModalReassignIncident from './Modals/ModalReassignIncident';
import ModalResolveIncident from './Modals/ModalResolveIncident';
import ModalRunIncidentWorkflow from './Modals/ModalRunIncidentWorkflow';
import ModalSidebarSettings from './Modals/ModalSidebarSettings';
import ModalUnlinkIncident from './Modals/ModalUnlinkIncident';
import IssueSidebar from './IssueSidebar';

const IssueSidebarMain = () => (
  <Switch>
    <Route path="/integration-jira-ui/issue_sidebar/modal_link_users" component={ModalLinkUsers}/>
    <Route path="/integration-jira-ui/issue_sidebar/modal_reassign_incident" component={ModalReassignIncident}/>
    <Route path="/integration-jira-ui/issue_sidebar/modal_run_incident_workflow" component={ModalRunIncidentWorkflow}/>
    <Route path="/integration-jira-ui/issue_sidebar/modal_create_incident" component={ModalCreateIncident}/>
    <Route path="/integration-jira-ui/issue_sidebar/modal_link_incident" component={ModalLinkIncident}/>
    <Route path="/integration-jira-ui/issue_sidebar/modal_sidebar_settings" component={ModalSidebarSettings}/>
    <Route path="/integration-jira-ui/issue_sidebar/modal_acknowledge_incident" component={ModalAcknowledgeIncident}/>
    <Route path="/integration-jira-ui/issue_sidebar/modal_resolve_incident" component={ModalResolveIncident}/>
    <Route path="/integration-jira-ui/issue_sidebar/modal_add_note" component={ModalAddNote}/>
    <Route path="/integration-jira-ui/issue_sidebar/modal_unlink_incident" component={ModalUnlinkIncident}/>
    <Route path="/integration-jira-ui/issue_sidebar/modal_add_responders" component={ModalAddResponders}/>
    <Route path="/integration-jira-ui/issue_sidebar/modal_change_priority" component={ModalChangePriority}/>
    <Route path="/integration-jira-ui/issue_sidebar" component={IssueSidebar}/>
  </Switch>
);

export default IssueSidebarMain;
